var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoSolarspill(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-204 206 90 90",
    style: {
      enableBackground: "new -204 206 90 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#F79B46;}\r\n\t.st1{fill:none;stroke:#4E4D50;stroke-width:2.9692;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st2{fill:#F79B46;stroke:#F79B46;stroke-width:2.9692;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-159,236.6c7.4,0,13.4,6,13.4,13.4s-6,13.4-13.4,13.4c-7.4,0-13.4-6-13.4-13.4S-166.4,236.6-159,236.6  M-159,233.7c-9,0-16.3,7.3-16.3,16.3s7.3,16.3,16.3,16.3c9,0,16.3-7.3,16.3-16.3S-150,233.7-159,233.7L-159,233.7z"
  })), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: -159,
    y1: 242.1,
    x2: -159,
    y2: 256.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: -159,
    y1: 209.4,
    x2: -159,
    y2: 227.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: -159,
    y1: 274.8,
    x2: -159,
    y2: 292.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: -195,
    y1: 230.2,
    x2: -179.6,
    y2: 239.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: -138.4,
    y1: 262.9,
    x2: -123,
    y2: 271.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: -195,
    y1: 271.8,
    x2: -179.6,
    y2: 262.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: -138.4,
    y1: 239.1,
    x2: -123,
    y2: 230.2
  })), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: -166.4,
    y1: 249.5,
    x2: -151.6,
    y2: 249.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSolarspill);
export default __webpack_public_path__ + "static/media/ico_solarspill.f328c1d5abec4739bd985ad92a3aa2dd.svg";
export { ForwardRef as ReactComponent };